var jQuery = require("jquery");

(function($) {

    $(function() {

        $('.faq_item').each(function() {
            var $answer = $(this).find('.answer');
            $(this).find('.question').click(function() {
                $answer.slideToggle();
                return false;
            });
            $answer.hide();
        });
        
    });

})(jQuery);


// WEBPACK FOOTER //
// ./assets/js/mavo.js